export default __webpack_public_path__ + "static/media/turistas-sacando-foto-lago-vista-volcan.6c07640e.jpeg";